import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Container } from '@mui/material';
import type { SxProps } from '@mui/material';
type PageContainerType = React.PropsWithChildren & {
  sx?: SxProps;
  disableGutters?: boolean;
};
export const PageContainer = t0 => {
  const $ = _c(6);
  const {
    children,
    sx,
    disableGutters: t1
  } = t0;
  const disableGutters = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== sx) {
    t2 = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      ...sx
    };
    $[0] = sx;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== disableGutters || $[4] !== t2) {
    t3 = <Container maxWidth={false} disableGutters={disableGutters} sx={t2}>{children}</Container>;
    $[2] = children;
    $[3] = disableGutters;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};